import { configureStore } from '@reduxjs/toolkit';
import starshipsReducer from './starships/starships-reducer';
import {employeesSlice} from "./employees/employees-reducer";

export default configureStore({
  reducer: {
    starships: starshipsReducer,
    employees: employeesSlice
  }
});